import React from "react";
import UserForm from "./components/UserForm";
import ApiTokens from "./components/ApiTokens";
import DeleteAccount from "./components/DeleteAccount";

const Settings = () => {
  return (
      <div className="space-y-4">
        <UserForm/>
        <ApiTokens/>
        <DeleteAccount/>
      </div>
  )
}

export default Settings
